<template>
  <v-row>
    <LabelCol v-if="isLabelVisible" :cols="labelCols" :attribute="attribute" />
    <v-col :cols="valueCols/2" class="pa-0 pr-1">
      <v-text-field
        label="PL"
        :readonly="!canEdit"
        :disabled="isCopied"
        :value="fixedValue.pl"
        @input="setValuePL"
        :loading="loading"
        outlined
        :rules="rules"
        v-bind="inputProps"
      />
    </v-col>
    <v-col :cols="valueCols/2" class="pa-0">
      <v-text-field
        label="EN"
        :readonly="!canEdit"
        :disabled="isCopied"
        :value="fixedValue.en"
        @input="setValueEN"
        :loading="loading"
        :rules="rules"
        outlined
        v-bind="inputProps"
      />
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

import { DICTS } from '@/dicts';

export default {
  components: {
    LabelCol
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  computed: {
    dicts: () => DICTS,
    fixedValue() {
      if (!this.value) {
        return {
          pl: null,
          en: null
        };
      } else {
        return this.value;
      }
    },
    rules() {
      const rules = [];
      if (this.attribute.name === 'nazwa_nieruchomosci') {
        rules.push(v => (v && v.length <= 28) || this.$i18n.t('default.shorterThan'));
      }
      if (this.attribute.required) {
        rules.push(value => !!value || this.$i18n.t('default.requiredField'));
      }
      return rules;
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    },
    setValuePL(value) {
      this.setValue({
        ...this.fixedValue,
        pl: value
      });
    },
    setValueEN(value) {
      this.setValue({
        ...this.fixedValue,
        en: value
      });
    }
  }
};
</script>
